import React from "react";
import { Row, Col, Card, Typography, Flex, Input, Select, DatePicker } from "antd";
import { styled } from "@mui/system";
const DataSheet = styled('div')`
    .ant-card-small >.ant-card-body {
      padding: 8px 6px;}
`;
export default function FormGrid({ formItems = [], viewType }) {
  const { Text } = Typography;
  const { Option } = Select;
  const { TextArea } = Input;

  const configSelectMap = {
    constant: {
      idField: "id",
      label: (o) => o.title,
    },
    products: {
      idField: "netsuite_id",
      label: (o) => `${o.code} - ${o.name}`,
    },
    locations: {
      idField: "id",
      label: (o) => `${o.code}`,
    },
    helpers: {
      idField: "id",
      label: (o) => `${o.first_name} ${o.last_name}`,
    },
  };

  return (
    <DataSheet>
      <Row gutter={[4, 4]}>
        {formItems.map((item, index) => {
          return (
            <Col xs={24} sm={12} md={12} lg={viewType == 'Modal' ? 12 : 8} xl={viewType == 'Modal' ? 12 : 8} key={index}>
              <Card
                size="small"
                style={{
                  borderRadius: 12,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                  marginBottom: 4,
                }}
              >
                <Flex align="center" gap={8}>
                  {item.icon}
                  <span style={{ fontWeight: 600, fontSize: '14px', color: "#595959" }}>
                    {item.label}
                  </span>
                </Flex>
                {
                  (item?.type == 'text' || item?.type === 'number') && (
                    <Input
                      placeholder={item?.label}
                      value={item.value}
                      readOnly={item.readOnly}
                      type={item?.type == 'number' && 'number'}
                      onChange={(e) => item?.onChange?.(e.target.value)}
                      status={item?.status}
                      style={{
                        background: item?.readOnly ? "#fafafa" : "#ffffff",
                        borderRadius: 8,
                        cursor: "default",
                        fontWeight: 500,
                        color: "#262626",
                        maxWidth: "100%",
                      }}
                    />
                  )
                }
                {
                  item?.type === 'select' && (
                    <Select
                      style={{ width: "100%" }}
                      showSearch
                      allowClear
                      disabled={item?.readOnly}
                      value={item?.value}
                      placeholder={item?.label}
                      filterOption={(input, option) =>
                        option?.children?.toLowerCase().includes(input.toLowerCase())
                      }
                      onChange={(value) => item?.onChange?.(value)}
                    >
                      {item?.options?.map((option) => {
                        const config = configSelectMap[item?.data] || configSelectMap.constant;
                        const id = option?.[config.idField];
                        const label = config.label(option);
                        return (
                          <Option key={id} value={id}>
                            {label}
                          </Option>
                        )
                      }
                      )}
                    </Select>
                  )
                }
                {item?.type === 'date' && (
                  <DatePicker
                    format={"DD-MM-YYYY"}
                    value={item?.value}
                    onChange={(date) => {item?.onChange?.(date)}}
                    style={{
                      width: "100%",
                    }}
                    placeholder={item?.label}
                    disabledDate={item?.disabledDate}
                    disabled={item?.readOnly}
                  />
                )}
                {item?.type === 'notes' && (
                  <TextArea
                   value={item?.value}
                   placeholder={item?.label}
                   onChange={(e) => item?.onChange?.(e.target.value)}
                   autoSize={{ minRows: 3, maxRows: 6 }} 
                  />

                )}
              </Card>
            </Col>
          )
        })}
      </Row>
    </DataSheet>
  );
}
